import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import type { OnActionArgs } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export function useSignInWithSSO() {
  const { t } = useTranslation(['interfaces-matrix']);
  const { showSnackbar } = useSnackbar();

  const signInWithSSO = useEventCallback((args: OnActionArgs) => {
    showSnackbar({
      color: 'warning',
      title: t('interfaces-matrix:appActions.SignInWithSSO'),
    });

    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  });

  return { signInWithSSO };
}
